import React from 'react';
import PropTypes from 'prop-types';
import BaseMarker from './BaseMarker';
import {getMapToiSymbol, MAP_PIN_TYPES} from '../../utils/markers';
import Source from '../../utils/source';

const POINT_COLORS = {
    DARK_BLUE: '#15326f',
    ORANGE: '#E85F24',
};

const ThingsOfInterestMarker = (props) => {
    const {
        name,
        source,
        label,
        zIndex,
        onClick,
        isHighlighted,
        isSelected,
        onHover,
        onHoverLeave,
        hoveredMarker,
        ...rest
    } = props;

    const hoveredOrSelected = () => {
        if (isSelected) {
            const selectedToiIcon = getMapToiSymbol(POINT_COLORS.DARK_BLUE);

            selectedToiIcon.scale = 1.25;
            selectedToiIcon.anchor = {x: 2, y: 2};
            return selectedToiIcon;
        }
        if (isHighlighted) {
            const hoveredToiIcon = getMapToiSymbol(POINT_COLORS.ORANGE);
            hoveredToiIcon.scale = 1.25;
            hoveredToiIcon.anchor = {x: 2, y: 2};
            return hoveredToiIcon;
        }
        return getMapToiSymbol(POINT_COLORS.ORANGE);
    };

    const hoveredOrSelectedZIndex = () => {
        if (isSelected) {
            return 998;
        }
        if (isHighlighted) {
            return 999;
        }
        return zIndex;
    };

    const heightOffset = name.length > 29 ? -105 : -90;
    const gaiaHeightOffset = name.length > 29 ? -75 : -60;
    const infoWindowOptions = {};
    infoWindowOptions.pixelOffset =
        source === Source.FOURSQUARE
            ? new google.maps.Size(-91, heightOffset)
            : new google.maps.Size(-91, gaiaHeightOffset);

    infoWindowOptions.infoBoxClearance = new google.maps.Size(15, 15);

    return (
        <BaseMarker
            name={name}
            title={name}
            source={source}
            label={{
                color: '#FFF',
                text: label,
                fontSize: isHighlighted || isSelected ? '15px' : '12px',
                fontWeight: 'bold',
                labelOrigin: {x: 10, y: 10},
            }}
            zIndex={hoveredOrSelectedZIndex()}
            icon={hoveredOrSelected()}
            onClick={onClick}
            onHover={onHover}
            onHoverLeave={onHoverLeave}
            isHighlighted={isHighlighted}
            hoveredMarker={hoveredMarker}
            isSelected={isSelected}
            infoWindowOptions={infoWindowOptions}
            pinType={MAP_PIN_TYPES.TOI}
            {...rest}
        />
    );
};

export default ThingsOfInterestMarker;

ThingsOfInterestMarker.propTypes = {
    map: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    position: PropTypes.shape({
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired,
    }).isRequired,
    label: PropTypes.string,
    isHighlighted: PropTypes.bool,
    isSelected: PropTypes.bool,
    zIndex: PropTypes.number,
};
